import { render, staticRenderFns } from "./product-page.vue?vue&type=template&id=b1f2f2bc&scoped=true"
import script from "./product-page.vue?vue&type=script&lang=js"
export * from "./product-page.vue?vue&type=script&lang=js"
import style0 from "./product-page.vue?vue&type=style&index=0&id=b1f2f2bc&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2f2bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpBreadcrumb: require('/home/vsts/work/1/s/components/product-page/pdp-breadcrumb.vue').default,PdpGallery: require('/home/vsts/work/1/s/components/product-page/pdp-gallery/index.vue').default,PdpDescription: require('/home/vsts/work/1/s/components/product-page/pdp-description/index.vue').default,PdpBuybox: require('/home/vsts/work/1/s/components/product-page/pdp-buybox/index.vue').default,PdpFeatures: require('/home/vsts/work/1/s/components/product-page/pdp-features/index.vue').default,PdpBundles: require('/home/vsts/work/1/s/components/product-page/pdp-bundles/index.vue').default,PdpProductCallouts: require('/home/vsts/work/1/s/components/product-page/pdp-product-callouts/index.vue').default,PdpReviews: require('/home/vsts/work/1/s/components/product-page/pdp-reviews/index.vue').default})
